export default function (product) {
  const { disponibilita } = product
  const { in_arrivo } = product
  if (
    disponibilita === 'Disponibile' ||
    (disponibilita === 'Non Disponibile' && in_arrivo === 'Show & Sell')
  ) {
    return true
  }
  return false
}
